export default function TrustSection() {
  return (
    <>
      {/* ===== PROVEN LEGAL RESULTS ===== */}
      <section className="trust-section" data-testid="trust-section">
        <div className="trust-inner">
          <div className="proven-card">
            <p className="proven-label">PROVEN LEGAL RESULTS</p>
            <div className="proven-stats">
              <div className="proven-stat" data-testid="stat-clients">
                <div className="proven-number">800,000+</div>
                <div className="proven-stat-label">CLIENTS ALREADY SUPPORTED</div>
              </div>
              <div className="proven-stat" data-testid="stat-recovered">
                <div className="proven-number">&pound;100M+</div>
                <div className="proven-stat-label">ALREADY RECOVERED FOR CLIENTS</div>
              </div>
            </div>
          </div>

          <div className="trust-body">
            <p>As a legal group, our firms have supported more than 800,000 clients over the past 15 years across a wide range of consumer and financial claims. Over that period, our group firms have helped recover in excess of &pound;100 million for clients through complaints, negotiated settlements and formal legal action where appropriate.</p>
            <p>We are regulated by the Solicitors Regulation Authority and operate within strict professional and ethical standards. This means your claim is handled within a regulated legal framework, with proper duties of care, confidentiality and professional accountability.</p>
          </div>
        </div>
      </section>

      {/* ===== WHY WORKING WITH A LAW FIRM ===== */}
      <section className="law-firm-section" data-testid="law-firm-section">
        <div className="law-firm-inner">
          <h2>Why Working With a Law Firm Matters</h2>
          <p>Many people choose to work with a law firm rather than a claims management company because law firms are trained in the legal process from end to end. We understand how claims are assessed, how compensation is calculated, and how lenders evaluate liability and settlement value. A claims management company is not able to litigate on cases where necessary, as a law firm we can. Always making sure your compensation is maximised.</p>
          <p>This understanding of quantum and legal positioning helps ensure that claims are properly framed, supported with evidence, and progressed through the appropriate legal channels to achieve the best outcome.</p>
          <div className="law-features">
            <div className="law-feature" data-testid="law-feature-1">
              <h4>Legal Expertise</h4>
              <p>Trained in dispute resolution and litigation strategy</p>
            </div>
            <div className="law-feature" data-testid="law-feature-2">
              <h4>Formal Legal Remedies</h4>
              <p>Ability to escalate beyond a complaints process</p>
            </div>
            <div className="law-feature" data-testid="law-feature-3">
              <h4>Acting in Your Best Interests</h4>
              <p>Professional duty of care and confidentiality</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== OUR COMMITMENT ===== */}
      <section className="commitment-section" data-testid="commitment-section">
        <div className="commitment-inner">
          <h2>Our Commitment to You</h2>
          <p>Our role is to act in your best interests, guide you through what can be a complex process, and ensure your claim is presented clearly, accurately and fairly. We deal with the legal and administrative work so that you do not have to, while keeping you informed at each stage of the process.</p>
        </div>
      </section>
    </>
  );
}
